import { memo } from "react";
import "./css/Milestone.css";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

const DATA = [
  {
    year: "2025",
    title: "Founder • BrainToDo (CRM+HRM)",
    description: "Shipped end-to-end platform (React/Flutter/Laravel) used daily by teams.",
    icon: navIcon1,
    color: "#61DAFB",
    tags: ["Founder", "SaaS", "Full-stack"],
    link: "https://braintodo.com",
  },
  {
    year: "2024",
    title: "Fintech at Scale • PayPlus Agent",
    description: "Live app moving huge numbers of transactions with real-time recharge & payments.",
    icon: navIcon3,
    color: "#2196F3",
    tags: ["Flutter", "Payments", "Prod"],
  },
  {
    year: "2023",
    title: "BASIS ICT Award — Winner",
    description: "‘Salebee’ recognized for innovation and performance.",
    icon: navIcon2,
    color: "#FF9800",
    tags: ["Award", "Innovation"],
  },
  {
    year: "2022",
    title: "100k app installed for HolyTune App",
    description: "Designed, documented, and optimized production APIs with auth & rate-limits.",
    icon: navIcon3,
    color: "#4CAF50",
    tags: ["Flutter", "APIs", "Laravel", "Docs"],
  },
  {
    year: "2021",
    title: "15+ Apps Shipped",
    description: "Published on Play Store & App Store; led builds, reviews, and releases.",
    icon: navIcon1,
    color: "#9C27B0",
    tags: ["Flutter", "iOS", "Android"],
  },
  {
    year: "2020",
    title: "10+ Apps Shipped",
    description: "Published on Play Store & App Store; led builds, reviews, and releases.",
    icon: navIcon1,
    color: "#9C27B0",
    tags: ["Flutter", "iOS", "Android"],
  },
  {
    year: "2018-19",
    title: "A full phase learning and experimentation of Flutter",
    description: "Stackoverflow, medium, blogs, dart practices .",
    icon: navIcon1,
    color: "#9C27B0",
    tags: ["Study","Flutter", "iOS", "Android"],
  },
];

export const Milestone = memo(() => {
  return (
    <section className="milestone-container" id="milestones" aria-label="Career milestones timeline">
      <h2 className="milestone-title">Career Milestones</h2>

      <div className="timeline">
        {DATA.map((m, i) => (
          <article
            key={`${m.year}-${i}`}
            className="milestone-card"
            style={{ ["--milestone-color"]: m.color }}
            aria-label={`${m.year}: ${m.title}`}
          >
            <div className="milestone-left">
              <span className="year-badge" aria-hidden>{m.year}</span>
              <div className="rail-dot" aria-hidden />
            </div>

            <div className="milestone-body">
              <div className="milestone-icon-wrap" aria-hidden>
                <img src={m.icon} alt="" className="milestone-icon" />
              </div>

              <header>
                <h3 className="milestone-heading">
                  {m.link ? (
                    <a href={m.link} target="_blank" rel="noopener noreferrer">
                      {m.title}
                    </a>
                  ) : (
                    m.title
                  )}
                </h3>
              </header>

              <p className="milestone-desc">{m.description}</p>

              {m.tags?.length > 0 && (
                <ul className="tag-row" aria-label="Technologies and themes">
                  {m.tags.map((t) => (
                    <li key={t} className="tag-chip">{t}</li>
                  ))}
                </ul>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
});
